import axios from '../../axios/axios.js';

const util = {
  restructurePoll(el) {
    let mostPopularOptions = this.getMostPopularOptions(el);
    let sections;

    if (!el.sections) {
      if (util.checkIfActive(Date.parse(el.closes_at))) {
        sections = el.voting_stats
          ? util.getVotingSections(el)
          : util.getEmptyVotingSections(el);
      } else {
        if (el.voting_stats) {
          sections = util.getVotingSections(el);
        }
      }
    } else {
      sections = el.sections;
    }

    return {
      id: el.post_id,
      authorId: el.author_id,
      authorName: el.author_name,
      body: el.body,
      totalVotes: el.votes_total,
      maxVotes: el.max_community_vote,
      numberOfComments: el.num_of_comments,
      active: util.checkIfActive(Date.parse(el.closes_at))
        ? 'Aktivno'
        : 'Neaktivno',
      mostPopularOption: mostPopularOptions,
      medias: el.medias ? el.medias : [],
      profilePictureURL: el.profile_pic.link,
      divDescription: el.div_description,
      sections: sections,
      votingId: el.voting_id,
      closesAt: el.closes_at,
      numberOfMedia: el.num_of_media,
      votingItemId: el.voting_item_id,
      is_pinned: el.is_pinned
    };
  },

  getInfoAboutVoting(poll) {
    return axios
      .post('post/get-voting-info', {
        voting_id: poll.voting_id
      })
      .then(({ data }) => {
        if (data.length === 0) {
          return util.getEmptyVotingSections(poll);
        }

        let colors = ['var(--primary-color)', '#EDEA38', '#DB4378', '#454C45'];

        let options = poll.voting_items.map(e => e.text);
        let optionsVotes = [];

        for (let i = 0; i < options.length; i++) {
          optionsVotes[i] = 0;
          data.forEach(e => (e.text === options[i] ? optionsVotes[i]++ : ''));
        }

        let totalSum = 0;

        for (var n in optionsVotes) {
          totalSum += optionsVotes[n];
        }

        //dobijanje
        let sections = [];
        let i = 0;
        options.forEach(e => {
          sections.push({
            label: e,
            percentage: Math.round((optionsVotes[i] / totalSum) * 100),
            color: colors[i]
          });
          i++;
        });

        return sections;
      })
      .catch(err => {
        console.log(err);
      });
  },
  getEmptyVotingSections(poll) {
    let colors = ['var(--primary-color)', '#EDEA38', '#DB4378', '#454C45'];
    let voting_items = poll.voting_items;
    let sections = [];
    let i = 0;
    voting_items.forEach(e => {
      sections.push({
        label: e.text,
        id: e.id,
        percentage: 0,
        color: colors[i]
      });
      i++;
    });

    return sections;
  },
  getVotingSections(poll) {
    let colors = ['var(--primary-color)', '#EDEA38', '#DB4378', '#454C45'];

    let totalSum = 0;
    let valuesOfVotingStatsObject = Object.values(poll.voting_stats[0]); //string
    let valuesOfVoting = valuesOfVotingStatsObject.map(i => parseInt(i, 10)); //number
    for (var n in valuesOfVoting) {
      totalSum += valuesOfVoting[n];
    }

    //dobijanje

    let voting_items = poll.voting_items;
    let sections = [];
    let i = 0;
    voting_items.forEach(e => {
      sections.push({
        label: e.text,
        id: e.id,
        percentage:
          totalSum === 0 ? 0 : Math.round((valuesOfVoting[i] / totalSum) * 100),
        color: colors[i]
      });
      i++;
    });
    return sections;
  },
  getMostPopularOptions(el) {
    let votingItems = el.voting_items;
    let popularOptions = [];
    if (el.voting_stats) {
      // debugger;
      let maxVotes = Math.max(...Object.values(el.voting_stats[0]));
      let stats = el.voting_stats[0];
      // for (let i = 0; i < Object.values(stats).length; i++) {
      for (let i = 0; i < votingItems.length; i++) {
        let key = 'o' + (i + 1) + '_count';
        if (stats[key] == maxVotes) {
          popularOptions.push(votingItems[i].text);
        }
      }
    } else {
      return 'Nema glasova';
    }
    return popularOptions.join(', ');
  },
  checkIfActive(closesAtDate) {
    return closesAtDate > new Date();
  },
  restructureComments(data) {
    return data.map(el => {
      return {
        member_id: el.author_id,
        full_name: el.author_name,
        comment_body: el.body,
        link: el.profile_pic.link,
        timestamp: el.date,
        com_media_link: el.medias == null ? null : el.medias[0].link,
        numOfResponses: el.num_of_comments,
        comment_id: el.comment_id,
        medias: el.medias ? el.medias : []
      };
    });
  }
};

export default {
  state: {
    basicInfo: null,
    pollDetails: '',
    comments: null,
    userPicUrl: '',
    voters: []
  },
  mutations: {
    setPoll(state, payload) {
      state.pollDetails = payload;
    },
    setBasicPollInfo(state, payload) {
      state.basicInfo = payload;
      localStorage.setItem('k-p-m', JSON.stringify(payload));
    },
    setComments(state, payload) {
      state.comments = payload;
    },
    setUserPicUrl(state, payload) {
      state.userPicUrl = payload;
    },
    setVoters(state, payload) {
      state.voters = payload;
    },
    unsetPoll(state) {
      state.basicInfo = null;
      state.pollDetails = '';
      state.comments = null;
      state.userPicUrl = '';
      state.voters = [];
    }
  },
  actions: {
    getPollDetails(context) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-posts', {
          community_id: context.rootState.communities.activeCommunity.id,
          filter_type: '2',
          futureOrPast: 1,
          media_only: false,
          post_id: context.state.basicInfo.pollId
        })
        .then(({ data }) => {
          // context.rootState.postTitle = data[0].body;
          context.rootState.postTitle = 'Glasanje';

          //ako je neaktivno glasanje i upravnik nije glasao
          if (
            !util.checkIfActive(Date.parse(data[0].closes_at)) &&
            !data[0].voting_stats
          ) {
            util.getInfoAboutVoting(data[0]).then(e => {
              let sections = e;
              data[0].sections = sections;
              let restructuredPoll = util.restructurePoll(data[0]);
              context.commit('setPoll', restructuredPoll);
              context.dispatch('getPollComments');
              context.dispatch('getVotingInfo');
              context.commit('loadingFinished', null, {
                root: true
              });
            });
          } else {
            let restructuredPoll = util.restructurePoll(data[0]);
            context.commit('setPoll', restructuredPoll);
            context.dispatch('getPollComments');
            context.dispatch('getVotingInfo');
            context.commit('loadingFinished', null, {
              root: true
            });
          }
        })
        .catch(err => {
          context.commit('setPoll', '');
          context.commit('loadingFinished', null, {
            root: true
          });
          console.log(err);
        });
    },
    getPollComments(context) {
      context.commit('loadingStarted', null, {
        root: true
      });
      axios
        .post('post/get-comments', {
          community_id: context.rootState.communities.activeCommunity.id,
          post_id: context.state.basicInfo.pollId,
          futureOrPast: 1,
          numOfPosts: 999
        })
        .then(({ data }) => {
          let restructuredComments = util.restructureComments(data);
          context.commit('setComments', restructuredComments);
          context.commit('loadingFinished', null, {
            root: true
          });
        })
        .catch(err => {
          console.log(err);
          context.commit('loadingFinished', null, {
            root: true
          });
        });
    },
    getVotingInfo(context) {
      axios
        .post('post/get-voting-info', {
          voting_id: context.state.pollDetails.votingId
        })
        .then(({ data }) => {
          context.commit('setVoters', data);
          console.log('VOTTEEERS', data);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },

  getters: {},
  namespaced: true
};
